import { Box } from "@mui/material";
import ColorPicker, { ColorPickerProps } from "react-best-gradient-color-picker";
import styles from "./SolidGradientColorPicker.module.scss";
export type Iprops = {
	onChange: (color: string) => void;
	color: string;
	hideColorTypeBtns?: boolean;
	hideOpacity?: boolean;
} & ColorPickerProps;

const SolidGradientColorPicker = ({
	onChange,
	color,
	hideColorTypeBtns = false,
	hideOpacity = false,
	...props
}: Iprops) => {
	return (
		<Box className={styles.container}>
			<ColorPicker
				hideGradientType
				hideColorTypeBtns={hideColorTypeBtns}
				hideOpacity={hideOpacity}
				value={color}
				onChange={onChange}
				{...props}
			/>
		</Box>
	);
};

export default SolidGradientColorPicker;
